import { useT } from 'i18n';
import SelectorIdioma from 'i18n/SelectorIdioma';
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from '../../context/autenticacion/authContext';


// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Modal,
  Input
} from "reactstrap";

// Estilos globales para el componente (se inyectan una sola vez)
const styles = `
  /* Navbar principal */
  .nav-bar-fixed {
    background: linear-gradient(135deg, rgba(12,14,19, 0.95), rgba(12,14,19, 0.98));
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(227,168,43, 0.2);
    padding: 0.5rem 1rem;
  }

  /* Logo */
  .photo {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    overflow: hidden;
    margin-right: 1rem;
  }
  
  .photo .p7-mono {
    display: flex; align-items: center; justify-content: center;
    width: 100%; height: 100%;
    background: #0c0e13; border: 1px solid #e3a82b; border-radius: 12px;
    color: #f3f1ea; font-family: Georgia, 'Times New Roman', serif;
    font-size: 18px; letter-spacing: 1px;
  }
  .photo .p7-mono sup { color: #e3a82b; font-size: 11px; top: -0.5em; }

  .photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Brand text */
  .navbar-brand {
    font-weight: 700;
    font-size: 1.1rem;
    background: linear-gradient(135deg, #fff, #e3a82b);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  /* Toggler buttons */
  .navbar-toggler {
    border: 1px solid rgba(227,168,43, 0.3);
    border-radius: 12px;
    padding: 0.5rem;
    transition: all 0.3s ease;
  }
  
  .navbar-toggler:hover {
    border-color: #e3a82b;
    background: rgba(227,168,43, 0.1);
  }
  
  .navbar-toggler-bar {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    margin: 4px 0;
    transition: all 0.3s ease;
  }

  /* Welcome box */
  .welcome-box {
    background: linear-gradient(135deg, rgba(227,168,43, 0.15), rgba(12,14,19, 0.08));
    border-radius: 50px;
    padding: 0.2rem 1rem 0.2rem 0.3rem;
    transition: all 0.3s ease;
    margin-right: 0.5rem;
  }
  
  .welcome-box:hover {
    background: linear-gradient(135deg, rgba(227,168,43, 0.25), rgba(12,14,19, 0.15));
  }
  
  .welcome-box-active {
    background: linear-gradient(135deg, rgba(255, 82, 82, 0.2), rgba(211, 47, 47, 0.1));
    border-radius: 50px;
    padding: 0.2rem 1rem 0.2rem 0.3rem;
    margin-right: 0.5rem;
  }
  
  .welcome-box-active:hover {
    background: linear-gradient(135deg, rgba(255, 82, 82, 0.3), rgba(211, 47, 47, 0.2));
  }

  /* Bienvenido interno */
  .bienvenido {
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  /* Avatar con iniciales */
  .avatar-initials {
    width: 32px;
    height: 32px;
    background: #e3a82b;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.9rem;
    color: white;
    box-shadow: 0 0 10px rgba(227,168,43, 0.2);
  }
  
  .welcome-box-active .avatar-initials {
    background: linear-gradient(135deg, #ff5252, #d32f2f);
  }

  /* Texto de bienvenida */
  .welcome-text {
    display: flex;
    flex-direction: column;
  }
  
  .user-name-display .name {
    font-weight: 600;
    font-size: 0.85rem;
    color: #fff;
    letter-spacing: 0.3px;
  }

  /* Badge DEMO */
  .Hola2 {
    display: inline-block;
    background: linear-gradient(135deg, #ff5252, #d32f2f);
    color: white;
    padding: 0.15rem 0.6rem;
    border-radius: 50px;
    font-size: 0.6rem;
    font-weight: 700;
    margin-left: 0.5rem;
    letter-spacing: 0.5px;
    vertical-align: middle;
    animation: pulseGlow 1.5s infinite;
  }

  /* Cerrar sesión */
  .salir {
    cursor: pointer;
    transition: color 0.3s ease;
    font-size: 0.85rem;
    font-weight: 500;
    margin-bottom: 0;
  }
  
  .salir:hover {
    color: #ff5252;
  }
  
  .icon-salir {
    cursor: pointer;
    transition: transform 0.3s ease, color 0.3s ease;
    font-size: 1rem;
    margin-left: 0.3rem;
  }
  
  .icon-salir:hover {
    transform: translateX(3px);
    color: #ff5252;
  }

  /* Logo en sidebar colapsado */
  .joema-2 {
    margin-bottom: 0;
    margin-right: 1rem;
  }
  
  .joema-2 img {
    height: 30px;
    width: auto;
    filter: brightness(0) invert(1);
  }

  /* Animación del badge DEMO */
  @keyframes pulseGlow {
    0%, 100% { opacity: 1; box-shadow: 0 0 0px rgba(255, 82, 82, 0); }
    50% { opacity: 0.9; box-shadow: 0 0 8px rgba(255, 82, 82, 0.5); }
  }

  /* Estilos para el collapse en móvil */
  @media (max-width: 992px) {
    .navbar-collapse {
      background: linear-gradient(135deg, #0c0e13, #0c0e13);
      padding: 1rem;
      border-radius: 16px;
      margin-top: 0.5rem;
      border: 1px solid rgba(227,168,43, 0.2);
    }
    
    .title-panther {
      width: 100%;
      margin-bottom: 0.5rem;
    }
    
    .welcome-box, .welcome-box-active {
      width: 100%;
      justify-content: space-between;
    }
    
    .bienvenido {
      justify-content: space-between;
      width: 100%;
    }
  }
`;

// Inyectar estilos si no existen
if (typeof document !== 'undefined') {
  const styleId = 'admin-navbar-styles';
  if (!document.getElementById(styleId)) {
    const styleTag = document.createElement('style');
    styleTag.id = styleId;
    styleTag.textContent = styles;
    document.head.appendChild(styleTag);
  }
}

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalSearch: false,
    };
  }

  toggleCollapse = () => {
    this.setState({ collapseOpen: !this.state.collapseOpen });
  };

  toggleModalSearch = () => {
    this.setState({ modalSearch: !this.state.modalSearch });
  };

  render() {
    return (
      <>
        <Navbar className="nav-bar-fixed" expand="lg">
          <Container fluid>
            <div className="photo">
              <span className="p7-mono" aria-label="Panther 7">P<sup>7</sup></span>
            </div>

            <div className="navbar-wrapper">
              <div className="navbar-toggle d-inline">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.props.toggleSidebar}
                  aria-label="Toggle sidebar"
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="#" onClick={e => e.preventDefault()}>
                {this.props.brandText}
              </NavbarBrand>
            </div>

            <button
              aria-expanded={this.state.collapseOpen}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              type="button"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>

            <Collapse navbar isOpen={this.state.collapseOpen}>
              <Nav className="ml-auto align-items-center p7n-barra" navbar>
                <li className="p7n-item"><MenuUsuario /></li>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <Modal
          modalClassName="modal-search"
          isOpen={this.state.modalSearch}
          toggle={this.toggleModalSearch}
        >
          <div className="modal-header">
            <Input id="inlineFormInputGroup" placeholder="SEARCH" type="text" />
            <button
              aria-label="Close"
              className="close"
              type="button"
              onClick={this.toggleModalSearch}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

// Menú del usuario: nombre + avatar; al hacer clic abre idioma, mi cuenta y cerrar sesión
const MenuUsuario = () => {
  const { t } = useT();
  const history = useHistory();
  const { demo_status, CerrarSesion } = useContext(AuthContext);
  const [usuario, setUsuario] = React.useState({ name: '', email: '' });
  const [abierto, setAbierto] = React.useState(false);
  const caja = React.useRef(null);

  React.useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const clienteAxios = (await import('config/axios')).default;
        const r = await clienteAxios.post('/api/client/profile');
        if (vivo) setUsuario({ name: r.data?.name || 'Inversor', email: r.data?.email || '' });
      } catch (error) {
        console.error('Error al obtener perfil:', error);
      }
    })();
    return () => { vivo = false; };
  }, []);

  React.useEffect(() => {
    if (!abierto) return undefined;
    const fuera = (e) => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    const tecla = (e) => { if (e.key === 'Escape') setAbierto(false); };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', tecla);
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', tecla);
    };
  }, [abierto]);

  const nombre = (usuario.name || '').trim();
  const inicial = nombre ? nombre.charAt(0).toUpperCase() : 'U';

  return (
    <div className="p7n-menu" ref={caja}>
      <button
        type="button"
        className={`p7n-usuario${demo_status === 'active' ? ' demo' : ''}${abierto ? ' abierto' : ''}`}
        aria-haspopup="menu"
        aria-expanded={abierto}
        onClick={() => setAbierto(!abierto)}
      >
        <span className="p7n-avatar" aria-hidden="true">{inicial}</span>
        <span className="p7n-nombre">{nombre}</span>
        {demo_status === 'active' && <span className="p7n-demo">DEMO</span>}
        <svg className="p7n-flecha" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </button>

      {abierto && (
        <div className="p7n-panel" role="menu">
          <div className="p7n-cab">
            <span className="p7n-avatar grande" aria-hidden="true">{inicial}</span>
            <div className="p7n-cab-txt">
              <strong>{nombre}</strong>
              {usuario.email && <small>{usuario.email}</small>}
            </div>
          </div>

          <div className="p7n-fila">
            <span>{t('comun.idioma')}</span>
            <SelectorIdioma />
          </div>

          <button type="button" role="menuitem" className="p7n-op" onClick={() => { setAbierto(false); history.push('/cliente/user-profile'); }}>
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 4-6 8-6s8 2 8 6" /></svg>
            {t('nav.cuenta')}
          </button>
          <button type="button" role="menuitem" className="p7n-op salir" onClick={() => { setAbierto(false); CerrarSesion(); }}>
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3" /><path d="M16 8l4 4-4 4" /><path d="M20 12H9" /></svg>
            {t('comun.cerrarSesion')}
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminNavbar;